<script>
import { mapGetters } from 'vuex';
import { frontendURL } from 'dashboard/helper/URLHelper';

export default {
  props: {
    accountId: { type: Number, default: 0 },
  },
  computed: {
    ...mapGetters({ globalConfig: 'globalConfig/get' }),
    dashboardPath() {
      return frontendURL(`accounts/${this.accountId}/dashboard`);
    },
  },
};
</script>

<template>
  <div class="m-3 mb-6 h-7 w-9 shrink-0 md:m-4 md:mb-10 md:h-[42.162px] md:w-[55.475px]">
    <router-link :to="dashboardPath" replace class="block size-full">
      <img
        :src="globalConfig.logoThumbnail"
        alt="Hoje360"
        class="size-full object-contain"
      />
    </router-link>
  </div>
</template>
